;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();export const locales = ['nl', 'en'] as const
export type Locale = (typeof locales)[number]

export type PageKey =
  | 'home'
  | 'about'
  | 'pricing'
  | 'planning'
  | 'time-tracking'
  | 'crm'
  | 'contact'
  | 'blog'
  | 'signup'
  | 'login'
  | 'legal-terms'
  | 'legal-privacy'
  | 'legal-cookie'
  | 'legal-security'
  | 'legal-api-terms'
  | 'legal-dpa'
  | 'legal-support-service'
  | 'legal-responsible-disclosure'
  | 'legal-subprocessors'
  | 'legal-acceptable-use'

type SlugConfig = {
  primary: string[]
  aliases?: string[][]
}

type PageDefinition = {
  key: PageKey
  slugs?: Record<Locale, SlugConfig>
}

export const pages: Record<PageKey, PageDefinition> = {
  home: {
    key: 'home',
  },
  about: {
    key: 'about',
    slugs: {
      nl: { primary: ['over-ons'] },
      en: { primary: ['about'] },
    },
  },
  pricing: {
    key: 'pricing',
    slugs: {
      nl: { primary: ['tarieven'], aliases: [['prijzen']] },
      en: { primary: ['pricing'] },
    },
  },
  planning: {
    key: 'planning',
    slugs: {
      nl: { primary: ['software', 'planning'], aliases: [['planning']] },
      en: { primary: ['software', 'planning'] },
    },
  },
  'time-tracking': {
    key: 'time-tracking',
    slugs: {
      nl: { primary: ['software', 'urenregistratie'], aliases: [['urenregistratie']] },
      en: { primary: ['software', 'time-tracking'] },
    },
  },
  crm: {
    key: 'crm',
    slugs: {
      nl: { primary: ['software', 'klantbeheer'], aliases: [['software', 'crm'], ['crm']] },
      en: { primary: ['software', 'crm'] },
    },
  },
  contact: {
    key: 'contact',
    slugs: {
      nl: { primary: ['contact'] },
      en: { primary: ['contact'] },
    },
  },
  blog: {
    key: 'blog',
    slugs: {
      nl: { primary: ['blog'] },
      en: { primary: ['blog'] },
    },
  },
  signup: {
    key: 'signup',
    slugs: {
      nl: { primary: ['aanmelden'], aliases: [['registreren']] },
      en: { primary: ['sign-up'] },
    },
  },
  login: {
    key: 'login',
    slugs: {
      nl: { primary: ['inloggen'] },
      en: { primary: ['login'] },
    },
  },
  'legal-terms': {
    key: 'legal-terms',
    slugs: {
      nl: { primary: ['juridisch', 'algemene-voorwaarden'] },
      en: { primary: ['legal', 'terms-and-conditions'] },
    },
  },
  'legal-privacy': {
    key: 'legal-privacy',
    slugs: {
      nl: { primary: ['juridisch', 'privacyverklaring'], aliases: [['privacy']] },
      en: { primary: ['legal', 'privacy-statement'], aliases: [['privacy']] },
    },
  },
  'legal-cookie': {
    key: 'legal-cookie',
    slugs: {
      nl: { primary: ['juridisch', 'cookiebeleid'] },
      en: { primary: ['legal', 'cookie-policy'] },
    },
  },
  'legal-security': {
    key: 'legal-security',
    slugs: {
      nl: { primary: ['juridisch', 'security'] },
      en: { primary: ['legal', 'security'] },
    },
  },
  'legal-api-terms': {
    key: 'legal-api-terms',
    slugs: {
      nl: { primary: ['juridisch', 'api-voorwaarden'] },
      en: { primary: ['legal', 'api-terms'] },
    },
  },
  'legal-dpa': {
    key: 'legal-dpa',
    slugs: {
      nl: { primary: ['juridisch', 'verwerkersovereenkomst'] },
      en: { primary: ['legal', 'data-processing-agreement'] },
    },
  },
  'legal-support-service': {
    key: 'legal-support-service',
    slugs: {
      nl: { primary: ['juridisch', 'support-en-servicebeleid'] },
      en: { primary: ['legal', 'support-and-service-policy'] },
    },
  },
  'legal-responsible-disclosure': {
    key: 'legal-responsible-disclosure',
    slugs: {
      nl: { primary: ['juridisch', 'responsible-disclosure'] },
      en: { primary: ['legal', 'responsible-disclosure'] },
    },
  },
  'legal-subprocessors': {
    key: 'legal-subprocessors',
    slugs: {
      nl: { primary: ['juridisch', 'subverwerkers'] },
      en: { primary: ['legal', 'subprocessors'] },
    },
  },
  'legal-acceptable-use': {
    key: 'legal-acceptable-use',
    slugs: {
      nl: { primary: ['juridisch', 'acceptable-use-policy'] },
      en: { primary: ['legal', 'acceptable-use-policy'] },
    },
  },
}

export type FooterSectionId = 'company' | 'product' | 'auth' | 'legal' | 'contact'

type FooterSection = {
  id: FooterSectionId
  items: PageKey[]
}

export const footerSections: FooterSection[] = [
  {
    id: 'company',
    items: ['home', 'about', 'blog'],
  },
  {
    id: 'contact',
    items: [],
  },
  {
    id: 'product',
    items: ['planning', 'time-tracking', 'crm', 'pricing'],
  },
  {
    id: 'auth',
    items: ['login', 'signup'],
  },
  {
    id: 'legal',
    items: ['legal-terms', 'legal-privacy', 'legal-cookie'],
  },
]

export function isLocale(value: string): value is Locale {
  return locales.includes(value as Locale)
}

function segmentsEqual(a: string[], b: string[]) {
  if (a.length !== b.length) {
    return false
  }

  return a.every((segment, index) => segment === b[index])
}

export function getPagePath(locale: Locale, key: PageKey): string {
  if (key === 'home') {
    return `/${locale}`
  }

  const slugConfig = pages[key].slugs?.[locale]
  if (!slugConfig) {
    return `/${locale}`
  }

  return `/${locale}/${slugConfig.primary.join('/')}`
}

export function matchPageBySlug(
  locale: Locale,
  slugParts: string[],
): { page: PageDefinition; isAlias: boolean } | null {
  const entries = Object.values(pages).filter((page) => page.key !== 'home')

  for (const page of entries) {
    const slugConfig = page.slugs?.[locale]
    if (!slugConfig) {
      continue
    }

    if (segmentsEqual(slugParts, slugConfig.primary)) {
      return { page, isAlias: false }
    }

    for (const alias of slugConfig.aliases ?? []) {
      if (segmentsEqual(slugParts, alias)) {
        return { page, isAlias: true }
      }
    }
  }

  return null
}
